import { Link } from 'react-router-dom';
import { movies, categories } from '@/mocks/movies';

export default function HeroSection() {
  const featuredMovies = movies.filter((m) => m.featured);

  return (
    <section className="relative w-full min-h-[620px] md:min-h-[700px] flex items-center overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: `url(https://readdy.ai/api/search-image?query=Dark%20cinematic%20movie%20theater%20interior%20with%20warm%20red%20velvet%20curtains%20and%20golden%20stage%20lighting%2C%20empty%20seats%20with%20dramatic%20spotlight%2C%20luxurious%20classic%20cinema%20atmosphere%2C%20rich%20deep%20colors%2C%20elegant%20theater%20architecture&width=1920&height=800&seq=hero-bg-cinema&orientation=landscape)`,
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-background-50" />

      <div className="relative z-10 w-full px-4 md:px-6 pt-20 pb-10">
        <div className="max-w-screen-2xl mx-auto">
          <div className="text-center mb-10">
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-primary-500/20 border border-primary-500/30 rounded-full mb-6">
              <i className="ri-fire-line text-primary-400 text-sm"></i>
              <span className="text-sm text-primary-300">每日更新 · 高清不缓冲</span>
            </div>
            <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading text-white mb-4 leading-tight">
              8090影院高清超清4K蓝光
            </h1>
            <p className="text-base md:text-lg text-white/70 max-w-2xl mx-auto leading-relaxed">
              影视大全免费在线观看，播放流畅不缓冲，电影电视剧综艺动漫全集持续更新
            </p>
            <div className="flex flex-wrap items-center justify-center gap-3 mt-8">
              {categories.map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className="px-5 py-2.5 bg-white/10 hover:bg-white/20 backdrop-blur-sm border border-white/20 rounded-full text-sm text-white transition-all whitespace-nowrap"
                >
                  <i className={`${cat.icon} mr-1.5`}></i>
                  {cat.name}
                </Link>
              ))}
            </div>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-5">
            {featuredMovies.map((movie, idx) => (
              <Link
                key={movie.id}
                to={`/article/${movie.id}`}
                className="group relative rounded-lg overflow-hidden aspect-[2/3]"
              >
                <img
                  src={movie.poster}
                  alt={movie.title}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-transparent" />
                <div className="absolute bottom-0 left-0 right-0 p-3 md:p-4">
                  <span className="inline-block px-2 py-0.5 bg-accent-500 text-white text-xs rounded mb-2">
                    {movie.quality[0]}
                  </span>
                  <h3 className="text-sm md:text-base font-semibold text-white line-clamp-1">{movie.title}</h3>
                  <div className="flex items-center gap-2 mt-1.5">
                    <span className="text-accent-400 text-xs">
                      <i className="ri-star-fill mr-0.5"></i>
                      {movie.rating}
                    </span>
                    <span className="text-white/50 text-xs">{movie.year}</span>
                  </div>
                </div>
                {idx === 0 && (
                  <div className="absolute top-3 left-3 px-2.5 py-1 bg-primary-500 text-white text-xs font-medium rounded">
                    热播推荐
                  </div>
                )}
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}